import { useState } from 'react'
import { HttpVerb } from '../../../../../types/api-types'
import { AquiferFieldsEdit } from '../../../../../types/form-types'
import { FormDelegate, PageNavigation } from '../../../../../types/routing-types'
import ConfirmTransition from '../../../../components/confirm-transition'
import { ERROR_MESSAGES } from '../../../../components/errors/messages'
import { EditAquiferForm } from '../../../../components/well-forms/aquifer/aquifer-edit-form'
import EditRecordButtons from '../../../../components/wells/edit-record-buttons'
import { useWellState } from '../../../../context/well-context'
import { useGetWellData, useSaveWellData } from '../../../../hooks/use-api'
import useEditForm from '../../../../hooks/use-edit-form'
import useToastMessage from '../../../../hooks/use-toast-message'
import { useWellId } from '../../../../hooks/use-well-id'
import { RecordContent, RecordFooter, useTitleChange } from '@msaf/core-react'

export function EditWellAquifer({ setIsDirty }: FormDelegate) {
  const {
    wellState: { isDraft },
  } = useWellState()
  useTitleChange(`${isDraft ? 'New' : 'Edit'} Well | Aquifer`)
  const wellId = useWellId()

  const urls: PageNavigation = {
    requestUrl: `/wells/${wellId}/aquifer/edit`,
    saveAndContinueRoute: (id) => `/wells/${wellId}/edit/drilling-tests`,
    cancelRoute: `/wells/${wellId}/view/aquifer`,
    method: HttpVerb.PUT,
  }

  const stateQueryResult = useGetWellData(urls.requestUrl)
  const saveMutationResult = useSaveWellData(urls.requestUrl, urls.method)

  const { fields, isLoading, error, isSaveError, setValue, handleSave, isSaved, isSuccess, validationErrors } =
    useEditForm<AquiferFieldsEdit>({
      stateQueryResult,
      saveMutationResult,
      setIsDirty,
    })

  useToastMessage({
    errorMessage: validationErrors ? ERROR_MESSAGES.VALIDATION_ERROR : ERROR_MESSAGES.SAVE_FAILED,
    successMessage: 'Save successful',
    error,
    isSuccess: isSaved && isSuccess,
    isError: isSaveError,
  })

  return (
    <>
      <RecordContent>
        <EditAquiferForm
          fields={fields}
          isLoading={isLoading}
          setValue={setValue}
          validationErrors={validationErrors ?? []}
        />
      </RecordContent>
      <RecordFooter areActionsFixed>
        <EditRecordButtons urls={urls} handleSave={handleSave} />
      </RecordFooter>
    </>
  )
}
export default function EditWellAquiferWrapped() {
  const [isDirty, setIsDirty] = useState<boolean>(false)
  return (
    <ConfirmTransition isFormDirty={isDirty}>
      <EditWellAquifer setIsDirty={setIsDirty} />
    </ConfirmTransition>
  )
}
